import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import SelectDropdown  from 'flarum/common/components/SelectDropdown';
import Stream from 'flarum/common/utils/Stream';
import { debounce } from 'flarum/common/utils/throttleDebounce';

import { copyToClipboard } from '../helpers/copyToClipboard';

export default class GenerateApplicationKeysModal extends Modal {
    oninit(vnode) {
        super.oninit(vnode);

        this.applications = [];
        this.isLoadingPage = true;
        this.generatedKeys = {};
        this.choosedUnitOfTime = 'minute';

        app.store.all('applications').filter((application) => application.canCreateKeys()).forEach((application) => {
            this.applications[application.id()] = {
                id: application.id(),
                name: application.name(),
                slug: application.slug(),
                active: Stream(false)
            };
        });

        this.isLoadingPage = false;
        m.redraw();
    }

    className() {
        return 'GenerateApplicationKeysModal Modal--small';
    }

    title() {
        return app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.label');
    }

    content() {
        const applications = this.applications;

        function handle_required() {
            let checkboxes = this.$('.checkbox :checkbox');
            if (checkboxes.is(':checked'))
                checkboxes.removeAttr('required');
            else
                checkboxes.attr('required', 'required');
        }

        function filter_number_input(dom) {
            if (dom?.value != '') {
                if (parseInt(dom.value) < parseInt(dom.min)) dom.value = dom.min;
                if (parseInt(dom.value) > parseInt(dom.max)) dom.value = dom.max;
            }
        }

        return (
            <div className="Modal-body">
                <div className="Form">
                    <div className="GenerateApplicationKeysModal">
                        <div className="Form-group ApplicationsGroup">
                            <label>{app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.applications')}</label>
                            <div>
                            {
                                applications.map((application) => (
                                    <label className="checkbox">
                                        <input
                                            type="checkbox"
                                            bidi={application.active}
                                            required
                                            oncreate={(vnode) => vnode?.dom.addEventListener('change', handle_required.bind(this, vnode?.dom)) }
                                        />
                                        { application.name }
                                    </label>
                                ))
                            }
                            </div>
                        </div>
                        <div className="Form-group">
                            <label>{app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.count')}</label>
                            <input id="count" min="1" max="500" type="number" className="FormControl" placeholder={app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.count_placeholder')} required oncreate={(vnode) => vnode?.dom.addEventListener('change', filter_number_input.bind(this, vnode?.dom)) } />
                        </div>
                        <div className="Form-group">
                            <label>{app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.time.label')}</label>
                            <div className="TimeGroup">
                                <input id="number" min="1" max="60" type="number" className="FormControl" placeholder={app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.time.placeholder')} required oncreate={(vnode) => vnode?.dom.addEventListener('change', filter_number_input.bind(this, vnode?.dom)) } />
                                <SelectDropdown
                                        icon="fas fa-ellipsis-v"
                                        buttonClassName="Button Button--primary"
                                        required
                                    >
                                        {
                                            ['minute','hour','day','week','month'].map((option) => (
                                                <Button active={this.choosedUnitOfTime === option} onclick={() => this.choosedUnitOfTime = option }>
                                                    {app.translator.trans(`xtreh-phoenix.forum.cheatpanel.grid.generate_keys.time.${option}`)}
                                                </Button>
                                            ))
                                        }
                                </SelectDropdown>
                            </div>
                        </div>
                        {
                            this.generatedKeys.keys?.length > 0 ?
                                <div className="ControlButtonsGroup">
                                    <Button className="Button Button--primary" onclick={() => {
                                        const name =
                                            this.applications.filter((application) => this.generatedKeys.appIds.includes(application.id)).map((application) => application.slug).join('+')
                                            + '_' + this.generatedKeys.number
                                            + this.generatedKeys.unitOfTime + (this.generatedKeys.number == 1 ? '':'s')
                                            + '_' + this.generatedKeys.count + 'k.txt';

                                        const content =
                                            this.generatedKeys.keys.map((key) =>
                                                key.id + ' ['
                                                + this.applications.filter((application) => this.generatedKeys.appIds.includes(application.id)).map((application) => application.slug).join('+')
                                                + ' - ' + this.generatedKeys.number + ' '
                                                + this.generatedKeys.unitOfTime + (this.generatedKeys.number == 1 ? '':'s')
                                                + "]\r\n"
                                            );

                                        this.saveAs(new Blob(content), name);
                                    }}>
                                        { app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.download') }
                                    </Button>
                                    <Button className="Button Button--primary" onclick={() => {
                                        this.alertAttrs = {
                                            dismissible: true,
                                            type: 'success',
                                            content: <div className="GeneratedKeysList">{this.generatedKeys.keys.map((key) => key.id + "\r\n")}</div>,
                                            controls: [
                                                <Button className="Button Button--link" onclick={() => {
                                                    const content =
                                                        this.generatedKeys.keys.map((key) =>
                                                            key.id + ' ['
                                                            + this.applications.filter((application) => this.generatedKeys.appIds.includes(application.id)).map((application) => application.slug).join('+')
                                                            + ' - ' + this.generatedKeys.number + ' '
                                                            + this.generatedKeys.unitOfTime + (this.generatedKeys.number == 1 ? '':'s')
                                                            + "]\r\n"
                                                        );

                                                    copyToClipboard(content.join(''));

                                                    let alert = app.alerts.show({ dismissible: true, type: 'success' }, app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.copied'));
                                                    debounce(2500, () => app.alerts.dismiss(alert))();
                                                }}>
                                                    {app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.copy')}
                                                </Button>
                                            ]
                                        };
                                    }} disabled={this.generatedKeys.keys?.length > 8}>
                                        { app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.show') }
                                    </Button>
                                </div>
                                :
                                <Button className="Button Button--primary" loading={this.loading} type="submit">
                                    { app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.generate') }
                                </Button>
                        }

                    </div>
                </div>
            </div>
        );
    }

    onsubmit(e) {
        e.preventDefault();

        this.loading = true;

        const timeToSeconds = {
            minute: 60,
            hour: 3600,
            day: 86400,
            week: 604800,
            month: 2592000
        };

        const appIds = this.applications
            .filter((application) => application.active())
            .map((application) => application.id);

        const numTime = $('#number').val(),
              numKeys = $('#count').val();

        app.request({
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/applications/keys',
            body: { data: { applications: appIds, seconds: timeToSeconds[this.choosedUnitOfTime] * numTime, count: numKeys } },
            errorHandler: this.onerror.bind(this)
        }).then((keys) => {
            this.generatedKeys = { keys: keys.data, number: numTime, count: numKeys, unitOfTime: this.choosedUnitOfTime, appIds: appIds };
            this.loading = false;
            m.redraw();
        }).catch(() => {
            this.loading = false;
            m.redraw();
        });

        /*
        let options = {
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/applications/keys',
            body: {
                data: {
                    apps: this.applications.filter((application) => application.active()).map((application) => application.id),
                    count: this.$('#count').val(),
                    days: this.$('#days').val()
                }
            },
            headers: { "X-CSRF-Token": app.session.csrfToken },
            filename: 'keys.txt'
        };

        m.request({
            ...options,
            responseType: 'blob',
            config: (xhr) => options.xhr = xhr
        }).then(async (response) => {
            this.generatedKeys = { data: await response.text(), filename: /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(options.xhr.getResponseHeader('Content-Disposition'))[1] };
            this.loaded();
        }).catch((error) => {
            error.response.text().then((response) => {
                try { error.response = JSON.parse(response); } catch (e) { error.status = 500; }
                error.options = options;
                error.status = error.code;
                app.requestErrorCatch(error, this.onerror.bind(this)).catch(() => {
                    this.loading = false;
                    m.redraw();
                });
            })
        });
        */
    }

    saveAs(blob, filename) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', filename);
        link.click();
        link.remove();
    }
}
